import {
  takeEvery,
  call,
  all,
  put,
} from 'redux-saga/effects';

import types from '../types';
import actions from '../actions';

import {
  patchAutoInvestApi,
} from '../../api';


export function* getDataFlow(action) {
  const {
    id,
    data,
    promise: {
      resolve,
      reject,
    } = {},
  } = action;
  try {
    const response = yield call(patchAutoInvestApi, id, data);
    yield all([
      call(resolve, { id, data: response.data }),
      put(
        actions.autoInvestUpdateSucceeded(
          id,
          response.data,
        ),
      ),
    ]);
  } catch (error) {
    yield all([
      call(reject, error),
      put(
        actions.autoInvestUpdateFailed(
          id,
          error,
        ),
      ),
    ]);
  }
}

export function* watchAutoInvestUpdateRequested() {
  yield takeEvery(
    types.AUTOINVEST_UPDATE_REQUESTED,
    getDataFlow,
  );
}

export default watchAutoInvestUpdateRequested;
